import { createEntityAdapter, createSlice, } from '@reduxjs/toolkit';
import { SliceStatus } from '../types/slices.types';
import { SliceRequest } from './utils';
export const pagesAdapter = createEntityAdapter({
    selectId: (model) => model.fields.handle,
});
export const componentsAdapter = createEntityAdapter({
    selectId: (model) => model.sys.id,
});
const initialState = {
    activeConversationId: null,
    status: {},
    pages: pagesAdapter.getInitialState(),
    currentPageId: null,
    error: null,
    pageComponents: componentsAdapter.getInitialState(),
};
export const fetchAllPages = SliceRequest('fetchAllPages', ({ api, locale, pageType }) => {
    return api.fetchData({
        contentType: 'page',
        locale,
        query: { 'fields.pageType': pageType },
    });
});
export const fetchPage = SliceRequest('fetchPage', ({ api, locale, handle, pageType }) => {
    return api.fetchData({
        contentType: 'page',
        locale,
        query: { 'fields.handle': handle, 'fields.pageType': pageType },
    });
});
export const fetchPageComponent = SliceRequest('fetchPageComponent', ({ api, locale, entryId, contentType }) => {
    return api.fetchData({
        contentType,
        locale,
        entryId,
    });
});
const pagesSlice = createSlice({
    name: 'pages',
    initialState,
    reducers: {
        setPagesStatus: (state, action) => {
            state.status = action.payload;
        },
        setPagesCurrentPageId: (state, action) => {
            state.currentPageId = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllPages.pending, (state) => {
            state.status = Object.assign(Object.assign({}, state.status), { fetchPages: SliceStatus.PENDING });
        })
            .addCase(fetchAllPages.fulfilled, (state, { payload }) => {
            if (Array.isArray(payload)) {
                state.pages = pagesAdapter.setAll(state.pages, payload);
            }
            else {
                state.pages = pagesAdapter.setOne(state.pages, payload);
            }
            state.status = Object.assign(Object.assign({}, state.status), { fetchPages: SliceStatus.IDLE });
        })
            .addCase(fetchAllPages.rejected, (state, action) => {
            if (action.payload) {
                state.error = action.payload.error;
            }
            state.status = Object.assign(Object.assign({}, state.status), { fetchPages: SliceStatus.IDLE });
        });
        builder
            .addCase(fetchPage.pending, (state) => {
            state.status = Object.assign(Object.assign({}, state.status), { fetchPages: SliceStatus.PENDING });
        })
            .addCase(fetchPage.fulfilled, (state, { payload }) => {
            if (Array.isArray(payload)) {
                state.pages = pagesAdapter.setAll(state.pages, payload);
            }
            else {
                state.pages = pagesAdapter.setOne(state.pages, payload);
            }
            state.status = Object.assign(Object.assign({}, state.status), { fetchPages: SliceStatus.IDLE });
        })
            .addCase(fetchPage.rejected, (state, action) => {
            if (action.payload) {
                state.error = action.payload.error;
            }
            state.status = Object.assign(Object.assign({}, state.status), { fetchPages: SliceStatus.IDLE });
        });
        builder
            .addCase(fetchPageComponent.pending, (state) => {
            state.status = Object.assign(Object.assign({}, state.status), { fetchPageComponent: SliceStatus.PENDING });
        })
            .addCase(fetchPageComponent.fulfilled, (state, { payload }) => {
            if (Array.isArray(payload)) {
                state.pageComponents = componentsAdapter.setAll(state.pageComponents, payload);
            }
            else {
                state.pageComponents = componentsAdapter.setOne(state.pageComponents, payload);
            }
            state.status = Object.assign(Object.assign({}, state.status), { fetchPageComponent: SliceStatus.IDLE });
        })
            .addCase(fetchPageComponent.rejected, (state, action) => {
            if (action.payload) {
                state.error = action.payload.error;
            }
            state.status = Object.assign(Object.assign({}, state.status), { fetchPageComponent: SliceStatus.IDLE });
        });
    },
});
export const { setPagesStatus, setPagesCurrentPageId } = pagesSlice.actions;
export const pagesReducer = pagesSlice.reducer;
export { pagesSlice };
